import formstackValidation from "./FormstackValidation";

const ValidateItem = (
	value,
	label,
	isRequired = false,
	validationRegex = "",
	minLength,
	maxLength,
	regexMessage = "",
	type = "text"
) => {
	let validateText = text => {
		if (isRequired && (!text || text.length <= 0)) {
			return `${label} is required`;
		} else if (minLength && text.length < minLength && !(!isRequired && (!text || text.length === 0))) {
			return `${label} must be at least ${minLength} characters`;
		} else if (maxLength && text.length > maxLength) {
			return `${label} must be shorter than ${maxLength} characters`;
		} else if (validationRegex !== "") {
			let patt = new RegExp(validationRegex);
			if (!patt.test(text) && !(!isRequired && (!text || text.length === 0))) {
				return regexMessage !== "" ? regexMessage : `${label} is invalid`;
			}
		}
		return null;
	};
	let validateBool = bool => {
		if (isRequired && (!bool || bool === false)) {
			return `${label} is required`;
		}
		return null;
	};
	switch (type) {
		case "text":
			return validateText(value);
		case "bool":
			return validateBool(value);
		case "textAndValueArray":
			if (isRequired && (!value || value.length <= 0)) {
				return `${label} is required`;
			} else {
				let result = null;
				(value || []).forEach(obj => {
					var error = validateText(obj.value);
					if (error !== null) {
						result = error;
					}
				});
				return result;
			}
		case "array":
			if (isRequired && (!value || value.length <= 0)) {
				return `${label} is required`;
			} else {
				let result = null;
				(value || []).forEach(item => {
					var error = validateText(item);
					if (error !== null) {
						result = error;
					}
				});
				return result;
			}
		case "formstack":
			return formstackValidation(value);
		case "oauth":
			if (!value.hasOwnProperty("oauthIntegrationId")) {
				return "Need to pick an Integration";
			}
			return null;
		default:
			return validateText(value);
	}
	//return null;
};

export default ValidateItem;
